export default {
  name: 'SharedMessage',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  methods: {
    getLevelImage: function getLevelImage(level) {
      return "url(/app/static/images/blank_level/".concat(Math.floor(level / 10), "0-").concat(Math.floor(level / 10), "9.png)");
    },
    openCardHandler: function openCardHandler() {
      var clientRect = this.$refs.message.getBoundingClientRect();
      this.$emit('opencard', this.data.uid, clientRect);
    }
  },
  mounted: function mounted() {
    this.$emit('scrollToEnd');
  }
};